import { MAX_RECONNECTION_TIMEOUT } from 'www/modules/Sockets/constants'

const MAX_SIGNIFICANT_RETRIES = Math.ceil(Math.log2(MAX_RECONNECTION_TIMEOUT / 1000))

export function calculateReconnectionTimeout(numberOfRetries) {
  const power = numberOfRetries > MAX_SIGNIFICANT_RETRIES ? MAX_SIGNIFICANT_RETRIES : numberOfRetries

  return 2 ** power * Math.random() * 1000
}
